<template>
  <div>
    <section
      v-if="applications?.length"
      class="
        persistent-scrollbar
        overflow-x-auto overflow-hidden
      "
      style="display: grid; gap: 16px;"
    >
      <v-card
        v-for="(item, itemIndex) in applications"
        :key="itemIndex"
        rounded="lg"
        elevation="0"
        background="white"
      >
        <v-card-text
          class="px-4 px-md-8"
        >
          <v-list
            dense
            color="trasparent"
            class="d-flex"
            style="gap: 42px;"
          >
            <v-list-item class="px-0">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-account-clock-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ references.recruiterStatus[item.recruiterStatus] }}
                </v-list-item-title>
                <v-list-item-subtitle>Statut du recruteur</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-application-parentheses-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.isSpontaneousApplication ? 'Oui' : 'Non' }}
                </v-list-item-title>
                <v-list-item-subtitle>Candidature spontanée</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-post-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.position?.name || 'N/A' }}
                </v-list-item-title>
                <v-list-item-subtitle>Poste</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="variant === 'other' && !item.isSpontaneousApplication"
              class="px-0"
            >
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-calendar
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.offer?.startDate ? formatDate(item.offer?.startDate, 'DD/MM/YYYY') : 'Pas de donnée' }}
                </v-list-item-title>
                <v-list-item-subtitle>Date de début</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="variant === 'other' && !item.isSpontaneousApplication"
              class="px-0"
            >
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-calendar
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.offer?.endDate ? formatDate(item.offer?.endDate, 'DD/MM/YYYY') : 'Pas de donnée' }}
                </v-list-item-title>
                <v-list-item-subtitle>Date de fin</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="variant === 'center'"
              class="px-0"
            >
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-briefcase-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.trade?.name || 'N/A' }}
                </v-list-item-title>
                <v-list-item-subtitle>Métier</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-domain
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.entity?.name }}
                </v-list-item-title>
                <v-list-item-subtitle>Centre</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-calendar
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ formatDate(item?.createTime, 'DD/MM/YYYY') }}
                </v-list-item-title>
                <v-list-item-subtitle>Postulé le</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </section>
    <section
      v-else
      class="
        d-flex justify-center align-center
        rounded-lg py-4
        white font-weight-medium grey--text
      "
    >
      Aucune donnée disponible
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { utils } from '@/mixins/index';

export default {
  name: 'ListApplications',
  mixins: [utils],
  props: {
    variant: {
      type: String,
      default: 'center'
    },
    applications: {
      type: Array,
      default: () => []
    }
  },
  computed: { ...mapState(['references']) }
};
</script>
